import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-tag-icon',
    templateUrl: './tag-icon.component.html',
    styleUrls: ['./tag-icon.component.scss']
})
export class TagIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 24;
        this.width = 24;
    }
}
